module.exports = __webpack_public_path__ + "img/Station Rendering_01_BRT.97a6919a.jpg";